module.exports = __webpack_public_path__ + "img/set-item3.88f3eecb.png";